// src/services/api/autorizacionesApi.ts
import axios from '../../utils/axios';

export interface SolicitudAutorizacion {
  codigoAccion: string;
  datosAccion: any;
}

export interface ProcesarAutorizacion {
  autorizar: boolean;
  observaciones?: string;
}

export interface AutorizacionPendiente {
  id: number;
  codigo: string;
  accion: {
    codigo: string;
    nombre: string;
    modulo: string;
  };
  solicitante: {
    id: number;
    nombre: string;
    usuario: string;
  };
  datosAccion: any;
  fechaSolicitud: string;
  fechaExpiracion: string;
  tiempoRestante: string;
}

export class AutorizacionesApi {
  /**
   * Solicitar una autorización
   */
  static async solicitarAutorizacion(data: SolicitudAutorizacion) {
    const response = await axios.post('/permisos/solicitar-autorizacion', data);
    return response.data;
  }

  /**
   * Procesar (autorizar o rechazar) una solicitud
   */
  static async procesarAutorizacion(
    codigo: string,
    data: ProcesarAutorizacion
  ) {
    const response = await axios.post(`/permisos/autorizar/${codigo}`, data);
    return response.data;
  }

  /**
   * Obtener autorizaciones pendientes (para supervisores)
   */
  static async obtenerPendientes(): Promise<AutorizacionPendiente[]> {
    const response = await axios.get('/permisos/pendientes');
    return response.data;
  }

  /**
   * Obtener mis solicitudes
   */
  static async obtenerMisSolicitudes() {
    const response = await axios.get('/permisos/mis-solicitudes');
    return response.data;
  }

  /**
   * Obtener historial de autorizaciones
   */
  static async obtenerHistorial() {
    const response = await axios.get('/permisos/historial');
    return response.data;
  }

  /**
   * Validar si puedo autorizar una acción
   */
  static async puedeAutorizar(codigoAccion: string): Promise<boolean> {
    const response = await axios.post('/permisos/puede-autorizar', {
      codigoAccion,
    });
    return response.data;
  }

  /**
   * Obtener cantidad de autorizaciones pendientes
   */
  static async contarPendientes(): Promise<number> {
    const response = await axios.get('/permisos/pendientes/count');
    return response.data.count;
  }

  /**
   * Obtener estado de una solicitud específica
   */
  static async obtenerEstadoSolicitud(codigo: string) {
    const response = await axios.get(`/permisos/estado-solicitud/${codigo}`);
    return response.data;
  }

  /**
   * Obtener módulos del usuario
   */
  static async obtenerModulos() {
    const response = await axios.get('/permisos/modulos');
    return response.data;
  }

  /**
   * Obtener acciones autorizables del usuario
   */
  static async obtenerAcciones() {
    const response = await axios.get('/permisos/acciones');
    return response.data;
  }
}